
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Subject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Subject"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ageGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allSlideImages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bigLogoImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buyStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"desc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invitePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indexContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"noticeContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pinkSalesNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pinkMinute"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesNum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pinkShareTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pinkShareContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smallLogoImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"titleImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoDesc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoDescCover"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"posterTplImg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSingle"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":485}};
    doc.loc.source = {"body":"fragment Subject on Subject {\n  ageGroup\n  allSlideImages\n  backImg\n  bigLogoImg\n  bonus\n  buyStatus\n  categoryId\n  content\n  desc\n  fullPrice\n  groupNum\n  groupPrice\n  invitePrice\n  id\n  indexContent\n  isGroup\n  itemNum\n  noticeContent\n  pinkSalesNum\n  pinkMinute\n  salesNum\n  shareContent\n  shareTitle\n  pinkShareTitle\n  pinkShareContent\n  smallLogoImg\n  sort\n  subTitle\n  title\n  titleImg\n  totalLength\n  unitId\n  updateDesc\n  videoDesc\n  videoDescCover\n  posterTplImg\n  isSingle\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Subject"] = oneQuery(doc, "Subject");
        
